export default __webpack_public_path__ + "e711740b4135b9a54e7e1644d14725af.svg";